/* eslint-disable no-unused-vars */
export enum OrderType {
  PICKUP = "PICKUP",
  DELIVERY = "DELIVERY",
  CURBSIDE = "CURBSIDE",
  DINE_IN = "DINE_IN",
  WEBSITE = "WEBSITE",
}
export const orderTypes = Object.values(OrderType);

export enum ServiceType {
  DINE_IN = "DINE_IN",
  PICKUP = "PICKUP",
  WEBSITE = "WEBSITE",
  CURBSIDE = "CURBSIDE",
  DELIVERY = "DELIVERY",
}

export enum CardOptionType {
  NONE = "NONE",
  SAVED_CARD = "SAVED_CARD",
  DIFFERENT_CARD = "DIFFERENT_CARD",
}

export enum Tag {
  MERCHANT_DETAILS = "MERCHANT_DETAILS",
  MENU = "MENU",
  ITEMS = "ITEMS",
  ITEM_DETAILS = "ITEM_DETAILS",
  CATEGORIES = "CATEGORIES",
  MERCHANT_POLICIES = "MERCHANT_POLICIES",
  MERCHANT_PREFERENCES = "MERCHANT_PREFERENCES",
  RETAIL_PICKUP_TIME = "RETAIL_PICKUP_TIME",
  CATEGORY_ITEMS = "CATEGORY_ITEMS",
  UNCATEGORY_ITEMS = "UNCATEGORY_ITEMS",
  MERCHANT_PAYMENT_CONFIG = "MERCHANT_PAYMENT_CONFIG",
  CUSTOMER_DETAILS = "CUSTOMER_DETAILS",
  ANY = "*",
}

export enum PipType {
  MERCHANT_INFO = "Merchant Info",
  MERCHANT_TYPE = "Merchant Type",
}

export enum MerchantBusinessType {
  ESSENTIAL_MERCHANT = "0",
  RESTAURANT = "1",
  SERVICE = "2",
  RETAIL = "4",
}

export enum CartItemType {
  RETAIL = "RETAIL",
  SERVICE = "SERVICE",
  RESTAURANT = "RESTAURANT",
}

export enum CartType {
  RETAIL_CART = "RETAIL_CART",
  SERVICE_CART = "SERVICE_CART",
  RESTAURANT_CART = "RESTAURANT_CART",
}

export enum CheckoutStep {
  CONTACT_INFO = "CONTACT_INFO",
  CHECKOUT_ORDER = "CHECKOUT_ORDER",
  AGE_VERIFICATION = "AGE_VERIFICATION",
  CANCELLATION_POLICY_COF = "CANCELLATION_POLICY_COF",
}

export enum AppointmentPolicyType {
  NONE = "NONE",
  CANCELLATION = "CANCELLATION",
  DEPOSIT = "DEPOSIT",
}

export enum PickupTimeType {
  ASAP = "ASAP",
  SCHEDULED = "scheduled",
}

export enum HeroCtaSpecial {
  ABOUT = "about",
}

export enum ShortDay {
  SUN = "Sun",
  MON = "Mon",
  TUE = "Tue",
  WED = "Wed",
  THU = "Thu",
  FRI = "Fri",
  SAT = "Sat",
}
export const shortDays = Object.values(ShortDay);

export enum WeekdayFull {
  SUNDAY = "sunday",
  MONDAY = "monday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
  THURSDAY = "thursday",
  FRIDAY = "friday",
  SATURDAY = "saturday",
}
export const daysOfWeek = Object.values(WeekdayFull);

export enum FulfillmentStatus {
  CONFIRMED = "CONFIRMED",
  COMPLETED = "COMPLETED",
  FULFILLED = "FULFILLED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  IN_PROGRESS = "IN_PROGRESS",
  CREATED = "CREATED",
  SCHEDULED = "SCHEDULED",
  READY_FOR_PICKUP = "READY_FOR_PICKUP",
  IN_PREPARATION = "IN_PREPARATION",
  PENDING = "PENDING",
  NO_SHOW = "NO_SHOW",
  DECLINED = "DECLINED"
}

